import { render, staticRenderFns } from "./restrictionStrategyAction.vue?vue&type=template&id=4d36cc4a"
import script from "./restrictionStrategyAction.vue?vue&type=script&lang=js"
export * from "./restrictionStrategyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports